import React, { Component } from 'react'
import {
  Header,
  Button,
  Segment,
  Form,
  Card,
  Message,
  Input,
} from 'semantic-ui-react'
import { ApolloConsumer, Mutation } from 'react-apollo'
import gql from 'graphql-tag'

import UserInput from './UserInput'

const UserCard = ({ user, onDelete, onShareReport, email }) => {
  return (
    <Card>
      <Card.Content>
        <Card.Header>{`${user.firstName} ${user.lastName}`}</Card.Header>
        <Card.Meta>{user.email}</Card.Meta>
        <Card.Description>
          What do you want to do with this user?
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div className="ui">
          <Mutation mutation={DELETE_USER}>
            {(deleteUser, { loading }) => {
              return (
                <Button
                  disabled={loading}
                  basic
                  color="red"
                  onClick={async () => {
                    await deleteUser({ variables: { id: user.id } })
                    onDelete()
                  }}
                >
                  {loading ? 'Deleting...' : 'Delete'}
                </Button>
              )
            }}
          </Mutation>
          <Mutation mutation={SHARE_REPORT}>
            {(shareReport, { loading }) => {
              return (
                <Button
                  disabled={loading}
                  basic
                  color="green"
                  onClick={async () => {
                    await shareReport({
                      variables: { id: user.id, input: { email: [email] } },
                    })
                    onShareReport()
                  }}
                >
                  {loading ? 'Sending...' : 'Send Pain Report'}
                </Button>
              )
            }}
          </Mutation>
        </div>
      </Card.Content>
    </Card>
  )
}

class FindUsers extends Component {
  state = {
    user: null,
    users: [],
    message: null,
    q: '',
    limit: 1,
    offset: 0,
    email: '',
  }

  handleChange = event => {
    this.setState({ [event.target.id]: event.target.value })
  }

  handleDismiss = () => this.setState({ message: null })

  onUserDelete = () => {
    this.setState({
      user: null,
      message: 'User deleted Successfully!',
    })
  }

  onShareReport = () => {
    this.setState({
      message: 'Painreport sent to user!',
    })
  }

  render() {
    const { user, message, q } = this.state
    return (
      <Segment>
        <Header as="h3">Find Users</Header>
        <ApolloConsumer>
          {client => {
            return (
              <Form>
                <div style={{ display: 'flex' }}>
                  <div style={{ width: '100%' }}>
                    <Form.Group>
                      <UserInput
                        id="q"
                        label="User Search Query"
                        value={q}
                        placeholder="Search users..."
                        onChange={this.handleChange}
                        width={14}
                      />
                    </Form.Group>

                    {message && (
                      <Message onDismiss={this.handleDismiss}>
                        <Message.Header>{message}</Message.Header>
                      </Message>
                    )}

                    <Button
                      onClick={async () => {
                        const { data } = await client.query({
                          query: USERS_SEARCH_QUERY,
                          variables: { q },
                        })
                        this.setState({
                          users: data.users,
                          user: data.users[0],
                        })
                      }}
                    >
                      Search
                    </Button>
                  </div>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    {user && (
                      <div>
                        <UserCard
                          user={user}
                          email={this.state.email}
                          onDelete={this.onUserDelete}
                          onShareReport={this.onShareReport}
                        />
                        <Input
                          style={{ width: '100%' }}
                          id="email"
                          placeholder="Enter email to share report..."
                          onChange={this.handleChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Form>
            )
          }}
        </ApolloConsumer>
      </Segment>
    )
  }
}

const USERS_SEARCH_QUERY = gql`
  query UserSearch($offset: Int, $limit: Int, $q: String!) {
    users(offset: $offset, limit: $limit, q: $q) {
      id
      firstName
      lastName
      email
      fbId
      scsState
    }
  }
`

const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
    }
  }
`

const SHARE_REPORT = gql`
  mutation ShareReport($id: ID!, $input: ShareReportInput!) {
    shareReport(id: $id, input: $input) {
      user {
        id
        email
      }
    }
  }
`

export default FindUsers
